import FormGroupRenderer from '@app/components/FormGroupRenderer'
import LotSizeInput from '@app/components/LotSizeInput'
import { Area } from '@app/models/Area'
import { ILot, Lot } from '@app/models/Lot'
import { bindFunctions } from '@app/utils/class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'

interface IComponentProps {
  className?: string
  isOpen: boolean
  onConfirmClick?: (e: ILot) => void
  onCancelClick?: () => void
  lot?: ILot
  style?: React.CSSProperties
}

interface IComponentState {
  isEditing: boolean
  lot: Lot
}

export default class LotEditorModal extends React.PureComponent<
  IComponentProps,
  IComponentState
> {
  constructor(props: any) {
    super(props)

    bindFunctions(this)

    this.state = {
      isEditing: this.props.lot ? true : false,
      lot:
        (this.props.lot as Lot) ||
        new Lot(),
    }
  }

  public componentWillReceiveProps(nextProps: any) {
    if (
      nextProps.lot &&
      this.props.lot &&
      nextProps.lot.id === this.props.lot.id
    ) {
      this.setState({
        isEditing: this.props.lot ? true : false,
        lot:
          (this.props.lot as Lot) ||
          new Lot(),
      })
    }
  }

  public render() {
    if (!this.state.lot) {
      return null
    }

    return (
      <Modal
        size='lg'
        centered
        isOpen={this.props.isOpen}
        toggle={() => this._cancelClick(!this.props.isOpen)}
      >
        <ModalHeader toggle={() => this._cancelClick(!this.props.isOpen)}>
          {this.props.lot ? `Edit - ${this.state.lot.lotNo}` : 'New Lot'}
        </ModalHeader>
        <ModalBody>{this._renderFields()}</ModalBody>
        <ModalFooter>
          <Button
            color='secondary'
            outline
            onClick={() => this._cancelClick(false)}
          >
            <FontAwesomeIcon icon={['fal', 'times']} fixedWidth /> Cancel
          </Button>
          <Button color='primary' onClick={this._confirmAction}>
            <FontAwesomeIcon icon={['fal', 'trash']} /> OK
          </Button>
        </ModalFooter>
      </Modal>
    )
  }

  private _cancelClick(value: boolean) {
    this.setState({
      isEditing: false,
    })

    if (this.props.onCancelClick) {
      this.props.onCancelClick()
    }
  }

  private _confirmAction() {
    if (this.props.onConfirmClick) {
      const lot =
        this.state.lot.id === ''
          ? (this.state.lot.set('id', `lot-${new Date().getTime()}`) as Lot)
          : (this.state.lot as Lot)

      this.setState({
        isEditing: false,
        lot: this.state.isEditing ? this.state.lot : new Lot(),
      })

      this.props.onConfirmClick(lot)
    }
  }

  private _renderFields() {
    return (
      <div>
        <FormGroupRenderer
          labelText='Lot No.'
          value={this.state.lot.lotNo}
          onChange={(e) => this._setLotNo(e)}
        />

        <FormGroupRenderer labelText='Lot Size'>
          <LotSizeInput
            className='flex-grow-1 w-100'
            bsSize='sm'
            onChange={(e: Area) => this._setLotSize(e)}
            value={this.state.lot.lotSize}
          />
        </FormGroupRenderer>

        <FormGroupRenderer
          labelText='APN / Parcel ID'
          value={this.state.lot.parcelId}
          onChange={(e) => this._setParcelId(e)}
        />

        <FormGroupRenderer
          labelText='Minimum Divisible'
          value={this.state.lot.minDivisible}
          type='number'
          onChange={(e) => this._setMinimumDivisble(e)}
        />

        <FormGroupRenderer
          labelText='Maximum Contiguous'
          value={this.state.lot.maxContiguous}
          type='number'
          onChange={(e) => this._setMaximumContiguous(e)}
        />

        <FormGroupRenderer
          labelText='Lot Description'
          value={this.state.lot.lotDescription}
          type='textarea'
          onChange={(e) => this._setLotDescription(e)}
        />
      </div>
    )
  }

  private _setMaximumContiguous(value: number) {
    this.setState({
      lot: this.state.lot.set('maxContiguous', value) as Lot,
    })
  }

  private _setMinimumDivisble(value: number) {
    this.setState({
      lot: this.state.lot.set('minDivisible', value) as Lot,
    })
  }

  private _setLotSize(value: Area) {
    this.setState({
      lot: this.state.lot.set('lotSize', value) as Lot,
    })
  }

  private _setLotDescription(value: string) {
    this.setState({
      lot: this.state.lot.set('lotDescription', value) as Lot,
    })
  }

  private _setLotNo(value: string) {
    this.setState({
      lot: this.state.lot.set('lotNo', value) as Lot,
    })
  }

  private _setParcelId(value: string) {
    this.setState({
      lot: this.state.lot.set('parcelId', value) as Lot,
    })
  }
}
